import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import LabelGeral from "../Componets/LabelGeral";
import DateGeral from "../Componets/DateGeral";
import Vector from "../imagem/Vector.svg";
import moment from "moment";
import InputAutoComplete from "../Componets/InputAutoComplete";
import iconPessoa from "../imagem/iconPessoa.svg";
import iconMais from "../imagem/iconMais.svg";
import "./EmprestarLivro.css";
import { useState } from "react";
import { formatarTelefone } from "../utils/formatarInputTelefone";

export default function EmprestarLivro({
  open,
  cancelar,
  emprestar,
  titulo,
  dataDevolvendo,
  setDataDevolvendo,
  options,
  alunoSelecionado,
  setAlunoSelecionado,
  nomeNovoAluno,
  setNomeNovoAluno,
  turmaNovoAluno,
  setTurmaNovoAluno,
  telefoneNovoAluno,
  setTelefoneNovoAluno,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    height: "auto",
    p: 4,
    borderRadius: 3,
  };

  const [abrirModalNovoAluno, setAbrirModalNovoAluno] = useState(false);

  const placeholderImagem = (
    <span style={{ display: "flex" }}>
      <img src={iconPessoa} alt="Icone" style={{ marginRight: "0.5em" }} />
      Selecione
    </span>
  );

  function hoje() {
    return moment().format("DD/MM/YYYY");
  }

  function fechandoModalNovoAluno() {
    setAbrirModalNovoAluno(false);
    cancelar()
  }

  const corrigindoTitulo = titulo?.length > 40 ? titulo.slice(0, 40) + "..." : titulo

  return (
    <div>
      <Modal
        open={open}
        onClose={cancelar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{ width: "100%", display: "flex", justifyContent: "end" }}
            >
              <Button
                onClick={() => {
                  fechandoModalNovoAluno();
                }}
              >
                <img src={Vector} alt="" />
              </Button>
            </div>
            <Typography variant="h6" component="h6">
              Efetuar empréstimo
            </Typography>
            <Typography variant="p" component="p" title={titulo} style={{marginBottom: 34}}>
              {corrigindoTitulo}
            </Typography>
          </div>

          <div style={{ display: "flex" }}>
            <InputAutoComplete
              label="Nome"
              placeholder={placeholderImagem}
              value={alunoSelecionado}
              change={(a) => setAlunoSelecionado(a)}
              options={options}
              style={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "--cor-cinzaMargin",
                  borderRadius: "0.8em",
                  height: 50,
                },
                marginTop: "0.5em",
                width: 300,
              }}
            />
            <button
              className="btn_mais"
              onClick={() => setAbrirModalNovoAluno(!abrirModalNovoAluno)}
            >
              <img src={iconMais} alt="icon mais" />
            </button>
          </div>

          {abrirModalNovoAluno && (
            <div className="caixa_novo_aluno">
              <p>Cadastrar novo aluno e efetuar empréstimo</p>
              <LabelGeral
                nome="Nome"
                estilo={{
                  display: "flex",
                  fontSize: 16,
                  marginBottom: "0.5em",
                }}
              />
              <input
                type="text"
                placeholder="Digite um nome"
                value={nomeNovoAluno}
                onChange={(e) => setNomeNovoAluno(e.target.value)}
              />
              <LabelGeral
                nome="Turma"
                estilo={{
                  display: "flex",
                  fontSize: 16,
                  marginBottom: "0.5em",
                }}
              />
              <input
                type="text"
                placeholder="Digite uma turma"
                value={turmaNovoAluno}
                onChange={(e) => setTurmaNovoAluno(e.target.value)}
              />
              <LabelGeral
                nome="Telefone"
                estilo={{
                  display: "flex",
                  fontSize: 16,
                  marginBottom: "0.5em",
                }}
              />
              <input
                type="text"
                placeholder="Digite um telefone"
                value={telefoneNovoAluno}
                onChange={(e) => setTelefoneNovoAluno(formatarTelefone(e.target.value))}
              />
            </div>
          )}

          <div
            style={{
              display: "flex",
              marginTop: 25,
              justifyContent: "space-between",
            }}
          >
            <div>
              <LabelGeral
                nome="Data atual"
                estilo={{
                  display: "flex",
                  fontSize: 16,
                  marginBottom: "0.5em",
                }}
              />
              <input
                disabled
                style={{
                  color: "var(--cor-preto)",
                  backgroundColor: "var(--cor-branco)",
                  border: "1px solid var(--cor-cinzaMargin)",
                  fontSize: 18,
                  borderRadius: 10,
                  width: 160,
                  height: 40,
                  fontFamily: "Roboto",
                }}
                value={hoje()}
              />
            </div>
            <div>
              <LabelGeral
                nome="Data de entrega"
                estilo={{
                  display: "flex",
                  fontFamily: "Roboto",
                  fontSize: 15,
                  marginBottom: "0.5em",
                }}
              />

              <DateGeral
                dataDevolvendo={dataDevolvendo}
                setDataDevolvendo={setDataDevolvendo}
              />
            </div>
          </div>

          <div
            className="buttons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 20,
              marginBottom: 25,
            }}
          >
            <Button
              onClick={() => {
                fechandoModalNovoAluno();
              }}
              variant="contained"
              style={{
                color: "var(--cor-roxoEscuro)",
                backgroundColor: "var(--cor-branco)",
                border: "2px solid var(--cor-roxoEscuro)",
                boxShadow: "none",
                borderRadius: "0.5em",
                fontSize: 20,
                width: 160,
                top: 25,
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => {
                fechandoModalNovoAluno();
                emprestar();
              }}
              variant="contained"
              style={{
                color: "var(--cor-branco)",
                backgroundColor: "var(--cor-roxoEscuro)",
                border: "solid var(--cor-roxoEscuro)",
                boxShadow: "none",
                borderRadius: "0.5em",
                fontSize: 20,
                width: 160,
                top: 25,
              }}
            >
              Emprestar
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
